/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Starter_Challenge_Phase_1_TitleInputs */

const en_starter_challenge_phase_1_title = /** @type {(inputs: Starter_Challenge_Phase_1_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Focus Starts Here`)
};

const ar_starter_challenge_phase_1_title = /** @type {(inputs: Starter_Challenge_Phase_1_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`يبدأ التركيز من هنا`)
};

const de_starter_challenge_phase_1_title = /** @type {(inputs: Starter_Challenge_Phase_1_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Der Fokus beginnt hier`)
};

const es_starter_challenge_phase_1_title = /** @type {(inputs: Starter_Challenge_Phase_1_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La concentración empieza aquí`)
};

const fr_starter_challenge_phase_1_title = /** @type {(inputs: Starter_Challenge_Phase_1_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La concentration commence ici`)
};

const it_starter_challenge_phase_1_title = /** @type {(inputs: Starter_Challenge_Phase_1_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La concentrazione inizia qui`)
};

const ja_starter_challenge_phase_1_title = /** @type {(inputs: Starter_Challenge_Phase_1_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`集中の第一歩`)
};

const ko_starter_challenge_phase_1_title = /** @type {(inputs: Starter_Challenge_Phase_1_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`집중은 여기서 시작됩니다`)
};

const pt_br_starter_challenge_phase_1_title = /** @type {(inputs: Starter_Challenge_Phase_1_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O foco começa aqui`)
};

const ru_starter_challenge_phase_1_title = /** @type {(inputs: Starter_Challenge_Phase_1_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Фокусировка начинается здесь`)
};

const th_starter_challenge_phase_1_title = /** @type {(inputs: Starter_Challenge_Phase_1_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`การโฟกัสเริ่มต้นที่นี่`)
};

const tr_starter_challenge_phase_1_title = /** @type {(inputs: Starter_Challenge_Phase_1_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Odaklanma Burada Başlıyor`)
};

const zh_cn_starter_challenge_phase_1_title = /** @type {(inputs: Starter_Challenge_Phase_1_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`专注，从这里开始`)
};

const zh_tw_starter_challenge_phase_1_title = /** @type {(inputs: Starter_Challenge_Phase_1_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`專注，從這裡開始`)
};

/**
* | output |
* | --- |
* | "Focus Starts Here" |
*
* @param {Starter_Challenge_Phase_1_TitleInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const starter_challenge_phase_1_title = /** @type {((inputs?: Starter_Challenge_Phase_1_TitleInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Starter_Challenge_Phase_1_TitleInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_starter_challenge_phase_1_title(inputs)
	if (locale === "ar") return ar_starter_challenge_phase_1_title(inputs)
	if (locale === "de") return de_starter_challenge_phase_1_title(inputs)
	if (locale === "es") return es_starter_challenge_phase_1_title(inputs)
	if (locale === "fr") return fr_starter_challenge_phase_1_title(inputs)
	if (locale === "it") return it_starter_challenge_phase_1_title(inputs)
	if (locale === "ja") return ja_starter_challenge_phase_1_title(inputs)
	if (locale === "ko") return ko_starter_challenge_phase_1_title(inputs)
	if (locale === "pt_br") return pt_br_starter_challenge_phase_1_title(inputs)
	if (locale === "ru") return ru_starter_challenge_phase_1_title(inputs)
	if (locale === "th") return th_starter_challenge_phase_1_title(inputs)
	if (locale === "tr") return tr_starter_challenge_phase_1_title(inputs)
	if (locale === "zh_cn") return zh_cn_starter_challenge_phase_1_title(inputs)
	return zh_tw_starter_challenge_phase_1_title(inputs)
});